enum PersistentNotificationTypeEnum {
    Primary,
    Secondary,
    Success,
    Danger,
    Warning,
    Info
}

export default PersistentNotificationTypeEnum;

export function getPersistentNotificationTypeClass(type: PersistentNotificationTypeEnum): string {
    switch (type) {
        case PersistentNotificationTypeEnum.Primary:
            return "badge-primary";
        case PersistentNotificationTypeEnum.Secondary:
            return "badge-secondary";
        case PersistentNotificationTypeEnum.Success:
            return "badge-success";
        case PersistentNotificationTypeEnum.Danger:
            return "badge-danger";
        case PersistentNotificationTypeEnum.Warning:
            return "badge-warning";
        case PersistentNotificationTypeEnum.Info:
            return "badge-info";
        default:
            return "badge-secondary";
    }
}
